import * as yup from "yup";

import { dobValidationSchema } from "@/containers/Dashboard/Providers/schema/newPatientValidation";

export const DEMOGRAPHIC_ELIGIBILITY_VALIDATION = yup.object().shape({
  dob: dobValidationSchema.required("Date of birth is required"),
  first_name: yup
    .string()
    .required("First name is required")
    .matches(/^[a-zA-Z-]+$/, "Numerals, spaces & special characters are not allowed"),
  last_name: yup
    .string()
    .required("Last name is required")
    .matches(/^[a-zA-Z-]+$/, "Numerals, spaces & special characters are not allowed"),
  mobile: yup
    .string()
    .matches(/^\d{10}$/, "Contact number must be a valid US number")
    .required("Mobile number is required"),
  mobile_validation: yup
    .string()
    .matches(/^\d{10}$/, "Contact number must be a valid US number")
    .required("Mobile number is required")
    .test(
      "mobile-match",
      "Mobile number does not match, please check the number",
      function (value) {
        if (!value) {
          return false;
        }

        return this.parent.mobile === value;
      },
    ),
  state_of_residence: yup.string().required("State of residence is required").nullable(),
});
